<template>
  <ul role="list" class="flex flex-1 flex-col gap-y-7">
    <li>
      <ul role="list" class="-mx-2 space-y-1">
        <li v-for="item in navigation" :key="item.name">
          <router-link
            :to="item.to"
            class="text-gray-700 hover:bg-gray-50 hover:text-primary-600 group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6"
            active-class="bg-gray-50 text-primary-600 *:text-primary-600"
          >
            <component :is="item.icon" class="h-6 w-6 shrink-0 text-gray-400 group-hover:text-primary-600" aria-hidden="true" />
            {{ item.name }}
          </router-link>
        </li>
      </ul>
    </li>
    <li v-if="links?.length">
      <div class="text-xs font-semibold leading-6 text-gray-400">
        Your links
      </div>
      <ul role="list" class="-mx-2 mt-2 space-y-1">
        <li v-for="link in links" :key="link.name">
          <a
            :href="link.href"
            target="_blank"
            class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-primary-600"
          >
            <span
              class="flex h-6 w-6 shrink-0 items-center justify-center
                rounded-lg border bg-white text-[0.625rem] font-medium border-gray-200 text-gray-400
                group-hover:border-primary-600 group-hover:text-primary-600"
            >{{ link.initial }}</span>
            <span class="truncate">{{ link.name }}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  navigation: {
    type: Array,
    default: () => []
  },
  links: {
    type: Array,
    default: () => []
  }
});
</script>
